import { Grid } from "@mui/material"
import type React from "react"
import type { ReactNode } from "react"
import { isMobile } from "react-device-detect"

// Define props for our responsive layout component
interface ResponsiveLayoutProps {
  imageContent: ReactNode
  textContent: ReactNode
  /** Immagine a sinistra e testo a destra (es. HomeRegister). Default: testo a sinistra come RegisterPrivate. */
  imageLead?: boolean
  spacing?: number
  /** Con imageLead, allinea le colonne in alto (stessa riga di partenza di immagine e testo). */
  alignColumnsTop?: boolean
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  imageContent,
  textContent,
  imageLead = false,
  spacing = 3,
  alignColumnsTop = false,
}) => {
  const rowAlign = alignColumnsTop ? "flex-start" : "stretch"

  if (isMobile) {
    return (
      <Grid container spacing={spacing} alignItems={rowAlign}>
        {imageLead ? (
          <>
            <Grid item xs={12}>
              {imageContent}
            </Grid>
            <Grid item xs={12}>
              {textContent}
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              {textContent}
            </Grid>
            <Grid item xs={12}>
              {imageContent}
            </Grid>
          </>
        )}
      </Grid>
    )
  }

  // Desktop: affiancate (ordine dipende da imageLead)
  return (
    <Grid container spacing={spacing} alignItems={rowAlign}>
      {imageLead ? (
        <>
          <Grid item xs={12} md={6}>
            {imageContent}
          </Grid>
          <Grid item xs={12} md={6}>
            {textContent}
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} md={6}>
            {textContent}
          </Grid>
          <Grid item xs={12} md={6}>
            {imageContent}
          </Grid>
        </>
      )}
    </Grid>
  )
}

export { ResponsiveLayout }

